import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  selectCarryForward({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('carryForwardManage/selectCarryForward', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  carryForwardSave({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`carryForwardManage/carryForwardSave`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteCarryForward({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`carryForwardManage/deleteCarryForward`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
